import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useFlag, useMutableRef } from '@carnica/utils/hooks';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
export var useAccordion = function useAccordion(_ref) {
  var isOpenProp = _ref.isOpen,
    onLabelClick = _ref.onLabelClick,
    _ref$initialIsOpen = _ref.initialIsOpen,
    initialIsOpen = _ref$initialIsOpen === void 0 ? false : _ref$initialIsOpen;
  var _useFlag = useFlag(initialIsOpen),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    isOpen = _useFlag2[0],
    setIsOpen = _useFlag2[1];
  var _useFlag3 = useFlag(initialIsOpen),
    _useFlag4 = _slicedToArray(_useFlag3, 2),
    actualOpen = _useFlag4[0],
    setActualOpen = _useFlag4[1];
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    processType = _useState2[0],
    setPropcessType = _useState2[1];
  var onLabelClickRef = useMutableRef(onLabelClick);
  var processTypeRef = useMutableRef(processType);
  var animationRef = useRef(null);
  var detailsRef = useRef(null);
  var summaryRef = useRef(null);
  var contentRef = useRef(null);
  var triggerAnimation = useCallback(function (flag) {
    if (detailsRef.current) {
      detailsRef.current.style.setProperty('--accordion-overflow', 'hidden');
    }
    if (flag === true || processTypeRef.current === 'closing' || !isOpen) {
      if (detailsRef.current) {
        detailsRef.current.style.setProperty('--accordion-height', "".concat(detailsRef.current.offsetHeight, "px"));
      }
      setIsOpen.on();
      window.requestAnimationFrame(function () {
        return animate(true);
      });
      setActualOpen.on();
      return true;
    }
    if (flag === false || processTypeRef.current === 'expanding' || isOpen) {
      animate(false);
      setActualOpen.off();
      return false;
    }
    return isOpen;
  }, [isOpen, processType]);
  var onClick = function onClick(e) {
    var _onLabelClickRef$curr;
    e.preventDefault();
    var isStateLessVersion = typeof isOpenProp === 'boolean' && !!onLabelClick;
    var flag = isStateLessVersion ? !isOpenProp : triggerAnimation();
    (_onLabelClickRef$curr = onLabelClickRef.current) === null || _onLabelClickRef$curr === void 0 ? void 0 : _onLabelClickRef$curr.call(onLabelClickRef, flag, e);
  };
  var animate = useCallback(function (flag) {
    if (detailsRef.current && summaryRef.current && contentRef.current) {
      setPropcessType(flag ? 'expanding' : 'closing');
      var from = "".concat(detailsRef.current.offsetHeight, "px");
      var to = "".concat(summaryRef.current.offsetHeight + (flag ? contentRef.current.offsetHeight : 0), "px");
      if (animationRef.current) {
        animationRef.current.cancel();
      }
      animationRef.current = detailsRef.current.animate({
        height: [from, to]
      }, {
        duration: 300,
        easing: 'ease-in'
      });
      animationRef.current.onfinish = function () {
        return onAnimationFinished(flag);
      };
      animationRef.current.oncancel = function () {
        return setPropcessType(undefined);
      };
    }
  }, []);
  var onAnimationFinished = useCallback(function (flag) {
    setIsOpen.set(flag);
    animationRef.current = null;
    setPropcessType(undefined);
    if (detailsRef.current) {
      detailsRef.current.style.setProperty('--accordion-overflow', 'visible');
      detailsRef.current.style.setProperty('--accordion-height', 'max-content');
    }
  }, []);
  useEffect(function () {
    if (typeof isOpenProp === 'boolean' && isOpenProp !== actualOpen) {
      triggerAnimation(isOpenProp);
      if (detailsRef.current) {
        detailsRef.current.style.setProperty('--accordion-overflow', isOpenProp ? 'visible' : 'hidden');
      }
    }
  }, [isOpenProp]);
  return useMemo(function () {
    return {
      detailsRef: detailsRef,
      summaryRef: summaryRef,
      contentRef: contentRef,
      onClick: onClick,
      isOpen: isOpen,
      actualOpen: actualOpen
    };
  }, [isOpen, actualOpen]);
};